// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .container {
        background-color: "#ffffff"
    }

    .paymentSuccessContainer {
        display:flex;
        flex-direction: column;
        align-items: center;
        height:100vh;
        width:100vw;
        justify-content: center;
    }
    .subContainer{
        /* margin-left: 10px;
        margin-right: 10px;
        margin-top: 15px; */
        /* display: flex;
        flex-direction: column;
        align-items: center;
        width: 100vw;
        border:1px solid red */
    }

    .paymentStatusCard {
        justify-content: "center";
        align-items: "center";
    }

    .statusText {
        font-size: 20;
        text-align: center;
    }

    .gifStyle {
        width:100px;
        padding-bottom: 20;
    }
    .imgContainer{
        display:flex;
        flex-direction:row;
        justify-content: center;
    }

    .orderDetailsContainer {
        width: 100%;
        align-self: center;
        display:flex;
        flex-direction: "row";  
        margin: 10px 5px;
    }

    .orderDetailsTitle {
        font-size: 10;
        margin-bottom: 0px;
        width: 120px;
        font-weight: "700";
        word-break: break-word;
    }

    .orderDetailsColon {
        font-weight: "700";
        margin: 0px 8px;
    }

    .orderDetailsValue {
        font-size: 10;
        word-break: break-word;
        margin-bottom: 0px;
    }`, "",{"version":3,"sources":["webpack://./src/components/paymentStatus/NativePaymentStatus.css"],"names":[],"mappings":"IAAI;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;QACZ,WAAW;QACX,uBAAuB;IAC3B;IACA;QACI;;2BAEmB;QACnB;;;;8BAIsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB","sourcesContent":["    .container {\n        background-color: \"#ffffff\"\n    }\n\n    .paymentSuccessContainer {\n        display:flex;\n        flex-direction: column;\n        align-items: center;\n        height:100vh;\n        width:100vw;\n        justify-content: center;\n    }\n    .subContainer{\n        /* margin-left: 10px;\n        margin-right: 10px;\n        margin-top: 15px; */\n        /* display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100vw;\n        border:1px solid red */\n    }\n\n    .paymentStatusCard {\n        justify-content: \"center\";\n        align-items: \"center\";\n    }\n\n    .statusText {\n        font-size: 20;\n        text-align: center;\n    }\n\n    .gifStyle {\n        width:100px;\n        padding-bottom: 20;\n    }\n    .imgContainer{\n        display:flex;\n        flex-direction:row;\n        justify-content: center;\n    }\n\n    .orderDetailsContainer {\n        width: 100%;\n        align-self: center;\n        display:flex;\n        flex-direction: \"row\";  \n        margin: 10px 5px;\n    }\n\n    .orderDetailsTitle {\n        font-size: 10;\n        margin-bottom: 0px;\n        width: 120px;\n        font-weight: \"700\";\n        word-break: break-word;\n    }\n\n    .orderDetailsColon {\n        font-weight: \"700\";\n        margin: 0px 8px;\n    }\n\n    .orderDetailsValue {\n        font-size: 10;\n        word-break: break-word;\n        margin-bottom: 0px;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
